import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "mt-8 space-y-5" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-5 lg:grid-cols-3" }
const _hoisted_4 = { class: "flex flex-col gap-4 rounded-2xl border-2 border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700" }
const _hoisted_7 = { class: "flex gap-1 rounded-lg bg-slate-100 p-1" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_10 = {
  key: 1,
  class: "rounded-xl border border-dashed border-slate-200 p-6 text-center"
}
const _hoisted_11 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "flex items-center gap-2.5" }
const _hoisted_14 = {
  key: 0,
  class: "h-4 w-4 text-green-600",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_15 = {
  key: 1,
  class: "h-4 w-4 text-blue-600",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_16 = { class: "min-w-0 flex-1" }
const _hoisted_17 = { class: "truncate text-sm font-semibold text-slate-800" }
const _hoisted_18 = { class: "space-y-5 lg:col-span-2" }
const _hoisted_19 = {
  key: 0,
  class: "flex items-center justify-center rounded-2xl border-2 border-dashed border-slate-200 bg-white p-16 shadow-sm"
}
const _hoisted_20 = {
  key: 1,
  class: "rounded-2xl border-2 border-slate-200 bg-white p-6 shadow-sm"
}
const _hoisted_21 = { class: "mb-6 flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between" }
const _hoisted_22 = { class: "flex items-center gap-2.5" }
const _hoisted_23 = {
  key: 0,
  class: "h-3 w-3",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_24 = {
  key: 1,
  class: "h-3 w-3",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_25 = { class: "text-lg font-bold text-slate-900" }
const _hoisted_26 = { class: "space-y-5" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "mb-2 block text-sm font-semibold text-slate-700" }
const _hoisted_29 = { class: "relative rounded-lg border border-slate-200 bg-white transition-all focus-within:border-blue-400 focus-within:ring-2 focus-within:ring-blue-500/30" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = ["rows", "placeholder"]
const _hoisted_32 = { class: "flex flex-wrap gap-2" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "text-xs italic text-slate-400"
}
const _hoisted_35 = { class: "flex flex-wrap items-center justify-end gap-3 border-t border-slate-100 pt-5" }
const _hoisted_36 = ["disabled"]

import { ref, computed, onMounted, nextTick } from 'vue'
import ApiService from '@/store/api.service'
import Swal from 'sweetalert2'
import Breadcrumb from '@/components/AppBreadcrumb.vue'
import PreviewPesanModal from '@/components/modal/PreviewPesanModal.vue'
import { usePermissions } from '@/hooks/usePermissions'
import { canAccessTemplate } from '@/utils/permissions'

type MessageTemplate = {
  id?: number
  key: string
  title: string
  subject?: string | null
  body: string
  variables?: string[] | string
  isActive?: boolean
  channel: 'email' | 'whatsapp'
}

const title = 'Template Pesan'


export default /*@__PURE__*/_defineComponent({
  __name: 'TemplatePesanView',
  setup(__props) {

const templates        = ref<MessageTemplate[]>([])
const selectedTemplate = ref<MessageTemplate | null>(null)
const channelFilter    = ref('')
const isLoading        = ref(false)
const isSaving         = ref(false)
const showPreviewModal = ref(false)
const { selectedRoleId } = usePermissions()

const form = ref({ subject: '', body: '' })

const channelTabs = [
  { value: '',          label: 'Semua' },
  { value: 'email',     label: 'Email' },
  { value: 'whatsapp',  label: 'WhatsApp' },
]

// ── Filtering ──────────────────────────────────────────────────────────────
const filteredTemplates = computed(() =>
  channelFilter.value
    ? templates.value.filter(t => t.channel === channelFilter.value)
    : templates.value
)

// ── Parsed variables ───────────────────────────────────────────────────────
const parsedVariables = computed<string[]>(() => {
  const raw = selectedTemplate.value?.variables
  if (Array.isArray(raw)) return raw
  if (typeof raw === 'string') {
    try {
      const p = JSON.parse(raw)
      return Array.isArray(p) ? p : []
    } catch { return [] }
  }
  return []
})

// ── Textarea variable highlighting overlay ─────────────────────────────────
const textareaRef = ref<HTMLTextAreaElement | null>(null)
const backdropRef = ref<HTMLDivElement | null>(null)

const syncScroll = () => {
  if (backdropRef.value && textareaRef.value) {
    backdropRef.value.scrollTop  = textareaRef.value.scrollTop
    backdropRef.value.scrollLeft = textareaRef.value.scrollLeft
  }
}

const variableTag = (name: string) => `{{${name}}}`

const escHtml = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

const highlightedBody = computed(() => {
  const esc = escHtml(form.value.body)
  return esc.replace(/\{\{([a-zA-Z0-9_]+)\}\}/g, (match, varName) =>
    parsedVariables.value.includes(varName)
      ? `<mark style="background:#dbeafe;color:#1d4ed8;border-radius:3px;padding:0 1px;">${match}</mark>`
      : match
  )
})

// ── Insert variable at cursor ──────────────────────────────────────────────
const insertVariable = (variable: string) => {
  const tag = `{{${variable}}}`
  const ta  = textareaRef.value
  if (ta) {
    const start   = ta.selectionStart ?? form.value.body.length
    const end     = ta.selectionEnd   ?? form.value.body.length
    form.value.body = form.value.body.slice(0, start) + tag + form.value.body.slice(end)
    nextTick(() => {
      ta.selectionStart = ta.selectionEnd = start + tag.length
      ta.focus()
    })
  } else {
    form.value.body += `${form.value.body ? ' ' : ''}${tag}`
  }
}

// ── Sample values for preview ──────────────────────────────────────────────
const SAMPLE_VALUES: Record<string, string> = {
  name:              'Budi Santoso',
  username:          'budi.santoso',
  donationType:      'Dana Sosial',
  amount:            '500.000',
  transactionId:     'TXN-2026-001',
  submission_id:     'TLY-ABC1234',
  form_slug:         'pengajuan_bantuan',
  respondent_id:     'RESP-001',
  code:              'ORD-2026-001',
  merchandise_name:  'Kaos IOM ITB',
  merchandiseName:   'Kaos IOM ITB',
  qty:               '2',
  items:             'Kaos IOM ITB (Size: L) x 2',
  order_status_url:  'https://iom-itb.ac.id/orders/ORD-2026-001',
  orderStatusUrl:    'https://iom-itb.ac.id/orders/ORD-2026-001',
  status:            'Dipanggil Wawancara',
  catatan_line:      'Harap membawa dokumen persyaratan lengkap.',
  updated_at:        '10 Mei 2026, 14.30',
}


// ── Data fetching ──────────────────────────────────────────────────────────
const fetchTemplates = async () => {
  isLoading.value = true
  try {
    const res  = await ApiService.get<any>('email-templates')
    const data = Array.isArray(res) ? res : (res as any)?.data || []
    const visibleTemplates = data.filter((template: MessageTemplate) =>
      canAccessTemplate(template, selectedRoleId.value)
    )
    templates.value = visibleTemplates
    if (visibleTemplates.length > 0) {
      selectTemplate(visibleTemplates[0])
    } else {
      selectedTemplate.value = null
      form.value = { subject: '', body: '' }
    }
  } catch (err) {
    console.error(err)
    await Swal.fire({ title: 'Gagal', text: 'Gagal mengambil template pesan.', icon: 'error', confirmButtonColor: '#1e40af', confirmButtonText: 'OK' })
  } finally {
    isLoading.value = false
  }
}

const selectTemplate = (template: MessageTemplate) => {
  selectedTemplate.value = template
  form.value = {
    subject: template.subject || '',
    body:    template.body    || '',
  }
}

const resetForm = () => {
  if (selectedTemplate.value) selectTemplate(selectedTemplate.value)
}

// ── Save ───────────────────────────────────────────────────────────────────
const saveTemplate = async () => {
  if (!selectedTemplate.value) return

  const isEmail = selectedTemplate.value.channel === 'email'

  if (isEmail && !form.value.subject.trim()) {
    await Swal.fire({ title: 'Gagal', text: 'Subject email wajib diisi.', icon: 'error', confirmButtonColor: '#1e40af', confirmButtonText: 'OK' })
    return
  }

  if (!form.value.body.trim()) {
    await Swal.fire({ title: 'Gagal', text: 'Isi pesan wajib diisi.', icon: 'error', confirmButtonColor: '#1e40af', confirmButtonText: 'OK' })
    return
  }

  isSaving.value = true
  try {
    const payload: Record<string, string> = { body: form.value.body }
    if (isEmail) payload.subject = form.value.subject

    await ApiService.put<any>(`email-templates/${selectedTemplate.value.key}`, payload)

    await Swal.fire({ title: 'Berhasil', text: 'Template berhasil disimpan.', icon: 'success', confirmButtonColor: '#1e40af', confirmButtonText: 'OK' })

    await fetchTemplates()
    const updated = templates.value.find(t => t.key === selectedTemplate.value?.key)
    if (updated) selectTemplate(updated)
  } catch (err) {
    console.error(err)
    await Swal.fire({ title: 'Gagal', text: 'Gagal menyimpan template.', icon: 'error', confirmButtonColor: '#1e40af', confirmButtonText: 'OK' })
  } finally {
    isSaving.value = false
  }
}

onMounted(fetchTemplates)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Breadcrumb, { breadcrumb: title }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", { class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
          _createElementVNode("div", { class: "relative" }, [
            _createElementVNode("h1", { class: "text-2xl font-bold tracking-tight md:text-4xl" }, _toDisplayString(title)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, " Kelola template pesan email dan WhatsApp yang dikirim otomatis kepada pemohon. ", -1))
          ])
        ]),
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-lg font-bold text-slate-900" }, "Daftar Template", -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString(filteredTemplates.value.length) + " template ", 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(channelTabs, (tab) => {
                return _createElementVNode("button", {
                  key: tab.value,
                  type: "button",
                  onClick: ($event: any) => (channelFilter.value = tab.value),
                  class: _normalizeClass(["flex-1 rounded-md px-2 py-1.5 text-xs font-semibold transition-all", channelFilter.value === tab.value
                ? 'bg-white text-slate-800 shadow-sm'
                : 'text-slate-500 hover:text-slate-700'])
                }, _toDisplayString(tab.label), 11, _hoisted_8)
              }), 64))
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                    return _createElementVNode("div", {
                      key: i,
                      class: "h-16 animate-pulse rounded-xl bg-slate-100"
                    })
                  }), 64))
                ]))
              : (!filteredTemplates.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("p", { class: "text-sm italic text-slate-400" }, "Tidak ada template.", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTemplates.value, (template) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: template.key,
                        type: "button",
                        onClick: ($event: any) => (selectTemplate(template)),
                        class: _normalizeClass(["w-full rounded-xl border px-3 py-3 text-left transition-all hover:bg-blue-50", selectedTemplate.value?.key === template.key
                ? 'border-blue-500 bg-blue-50'
                : 'border-slate-200 bg-white'])
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg", template.channel === 'whatsapp' ? 'bg-green-100' : 'bg-blue-50'])
                          }, [
                            (template.channel === 'whatsapp')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_14, [...(_cache[9] || (_cache[9] = [
                                  _createElementVNode("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" }, null, -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[10] || (_cache[10] = [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                                  }, null, -1)
                                ]))]))
                          ], 2),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("p", _hoisted_17, _toDisplayString(template.title), 1),
                            _createElementVNode("p", {
                              class: _normalizeClass(["text-xs", template.channel === 'whatsapp' ? 'text-green-600' : 'text-blue-500'])
                            }, _toDisplayString(template.channel === 'whatsapp' ? 'WhatsApp' : 'Email'), 3)
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["flex-shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold", template.isActive ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-500'])
                          }, _toDisplayString(template.isActive ? 'Aktif' : 'Nonaktif'), 3)
                        ])
                      ], 10, _hoisted_12))
                    }), 128))
                  ]))
          ]),
          _createElementVNode("div", _hoisted_18, [
            (!selectedTemplate.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("p", { class: "text-sm italic text-slate-400" }, "Pilih template terlebih dahulu.", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold", selectedTemplate.value.channel === 'whatsapp'
                    ? 'bg-green-100 text-green-700'
                    : 'bg-blue-100 text-blue-700'])
                      }, [
                        (selectedTemplate.value.channel === 'whatsapp')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_23, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_24, [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                              }, null, -1)
                            ]))])),
                        _createTextVNode(" " + _toDisplayString(selectedTemplate.value.channel === 'whatsapp' ? 'WhatsApp' : 'Email'), 1)
                      ], 2),
                      _createElementVNode("h2", _hoisted_25, _toDisplayString(selectedTemplate.value.title), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["inline-flex w-fit rounded-full px-3 py-1 text-xs font-semibold", selectedTemplate.value.isActive ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-500'])
                    }, _toDisplayString(selectedTemplate.value.isActive ? 'Aktif' : 'Nonaktif'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    (selectedTemplate.value.channel === 'email')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "mb-2 block text-sm font-semibold text-slate-700" }, "Subject Email", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.subject) = $event)),
                            type: "text",
                            class: "w-full rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm text-slate-700 transition-all focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30",
                            placeholder: "Masukkan subject email"
                          }, null, 512), [
                            [_vModelText, form.value.subject]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(selectedTemplate.value.channel === 'whatsapp' ? 'Pesan WhatsApp' : 'Isi Pesan Email'), 1),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", {
                          ref_key: "backdropRef",
                          ref: backdropRef,
                          class: "body-editor pointer-events-none absolute inset-0 overflow-hidden rounded-lg px-4 py-3",
                          style: {"color":"#334155"},
                          innerHTML: highlightedBody.value,
                          "aria-hidden": "true"
                        }, null, 8, _hoisted_30),
                        _withDirectives(_createElementVNode("textarea", {
                          ref_key: "textareaRef",
                          ref: textareaRef,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.body) = $event)),
                          rows: selectedTemplate.value.channel === 'whatsapp' ? 8 : 14,
                          onScroll: syncScroll,
                          class: "body-editor textarea-overlay relative w-full resize-none px-4 py-3",
                          placeholder: selectedTemplate.value.channel === 'whatsapp'
                      ? 'Masukkan pesan WhatsApp...'
                      : 'Masukkan isi pesan email...'
                        }, null, 40, _hoisted_31), [
                          [_vModelText, form.value.body]
                        ])
                      ]),
                      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "mt-1.5 text-xs text-slate-400" }, " Variabel yang dikenali ditandai dengan warna biru. Klik nama variabel di bawah untuk menyisipkannya. ", -1))
                    ]),
                    _createElementVNode("div", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("p", { class: "mb-2 text-sm font-semibold text-slate-700" }, "Variable yang dapat digunakan", -1)),
                      _createElementVNode("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsedVariables.value, (variable) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: variable,
                            type: "button",
                            onClick: ($event: any) => (insertVariable(variable)),
                            class: "rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-xs font-mono font-semibold text-blue-700 transition-colors hover:bg-blue-100"
                          }, _toDisplayString(variableTag(variable)), 9, _hoisted_33))
                        }), 128)),
                        (!parsedVariables.value.length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, " Tidak ada variabel untuk template ini. "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "rounded-lg border border-slate-200 bg-white px-5 py-2 text-sm font-semibold text-slate-600 transition-all hover:bg-slate-50",
                        onClick: resetForm
                      }, " Reset "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "rounded-lg border border-slate-300 bg-white px-5 py-2 text-sm font-semibold text-slate-700 transition-all hover:bg-slate-50",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (showPreviewModal.value = true))
                      }, " Preview & Test "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "rounded-lg bg-blue-900 px-6 py-2 text-sm font-bold text-white transition-all hover:bg-blue-800 disabled:cursor-not-allowed disabled:opacity-60",
                        disabled: isSaving.value,
                        onClick: saveTemplate
                      }, _toDisplayString(isSaving.value ? 'Menyimpan...' : 'Simpan Template'), 9, _hoisted_36)
                    ])
                  ])
                ]))
          ])
        ])
      ])
    ]),
    (showPreviewModal.value && selectedTemplate.value)
      ? (_openBlock(), _createBlock(PreviewPesanModal, {
          key: 0,
          template: selectedTemplate.value,
          body: form.value.body,
          subject: form.value.subject,
          "sample-values": SAMPLE_VALUES,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (showPreviewModal.value = false))
        }, null, 8, ["template", "body", "subject"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})